import Typography from '@mui/material/Typography';
interface DistanceIndicatorProps {
  distance: number | undefined;
  variant?: 'bodyMediumBook' | 'bodySmallBook';
  unit?: 'miles' | 'kilometers';
}
enum UnitAbbreviations {
  miles = 'mi',
  kilometers = 'ki',
}
export default function DistanceIndicator({
  distance,
  variant = 'bodyMediumBook',
  unit = 'miles'
}: DistanceIndicatorProps) {
  return <Typography color="text.tertiary" variant={variant} data-sentry-element="Typography" data-sentry-component="DistanceIndicator" data-sentry-source-file="DistanceIndicator.tsx">
			{distance && <div>
					{distance.toFixed(2)} {UnitAbbreviations[unit]}
				</div>}
		</Typography>;
}